

import {
  Box,
  Flex,
  Heading,
  HStack,
  Image,
  SimpleGrid,
  Spinner,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import SidebarWithHeader from "components/SidebarWithHeader";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectFbData } from "store/BmAccounts/bmAccountSlice";
import AiHub from "../assets/images/AboutAdspressoIcon/AI_hub.png";
import BotNull from "../assets/images/AboutAdspressoIcon/Bot_Nullifier.png";
import Bulk from "../assets/images/AboutAdspressoIcon/Bulk_Uploading.png";
import CreativeScoring from "../assets/images/AboutAdspressoIcon/Creative_Scoring.png";
import IntegratedIns from "../assets/images/AboutAdspressoIcon/Integrated_Insights.png";
import Rule from "../assets/images/AboutAdspressoIcon/Rule.png";
import Desktop from "../assets/images/AboutAdspressoIcon/Single_View_Dashboard.png";
import BidMultiplier from "../assets/images/AboutAdspressoIcon/Bid_Multiplier.png";
import AICallCenter from "../assets/images/AboutAdspressoIcon/ai-call-centre.png";
import AILander from "../assets/images/AboutAdspressoIcon/ai-lander.png";
import Whatsapp from "../assets/images/AboutAdspressoIcon/whatsapp.png";

const features = [
  {
    img: AICallCenter,
    title: "AI Call Center Support",
    desc: "Transform business calls with AI-powered pathways by unifying number management, flow builder, inbound/outbound calling, and call logging in one system. Built-in lead filtering ensures only high-intent leads reach sales teams, driving smarter optimisation, targeting, and ROI.",
  },
  {
    img: AILander,
    title: "AI Lander Generator",
    desc: "Transform ideas into production-ready interfaces instantly with AI-powered Text-to-UI, Image-to-UI, and Figma-to-UI. From simple concepts to complex applications, Canva generates beautiful, responsive designs and code in seconds.",
  },
  {
    img: Whatsapp,
    title: "AI WhatsApp Chatbot",
    desc: "Automate WhatsApp Business with AI-powered conversation pathways that connect directly through Meta Business Manager. Build intelligent flows, manage multiple numbers, and optimise engagement with real-time analytics.",
  },
  {
    img: Desktop,
    title: "Single View Dashboard",
    desc: "Simplify campaign management and reduce oversight errors with a unified view of all your Meta ad accounts.",
  },
  {
    img: Bulk,
    title: "Bulk Uploading",
    desc: "Cut ad setup time and boost ROAS by up to 30% by launching creatives and campaigns in bulk across multiple accounts, get to market faster and smarter.",
  },
  {
    img: BotNull,
    title: "Bot Nullifier",
    desc: "Improve ROI by eliminating bot traffic and automatically excluding inactive users after deploying high-intent audiences from across ad accounts.",
  },
  {
    img: AiHub,
    title: "AI Hub",
    desc: "Generate high-converting static and video creatives with a single click - reduce design time, improve CVRs, and drive up to 30% lower CPI.",
  },
  {
    img: Rule,
    title: "Rule Automation",
    desc: "Automate campaign actions to reduce manual monitoring and achieve consistent optimisation, even while you sleep.",
  },
  {
    img: CreativeScoring,
    title: "Creative Scoring",
    desc: "Accelerate decision-making with AI-backed creative scores, quickly spot what’s working and scale it to improve CTR and ROAS.",
  },
  {
    img: IntegratedIns,
    title: "Integrated Insights",
    desc: "Track granular performance data across creatives, CTAs, and campaigns to increase testing speed and reduce wasted ad spend.",
  },
  {
    img: BidMultiplier,
    title: "Bid Multiplier",
    desc: "Boost bids by up to 100% on your top-performing cohorts with a single click, say goodbye to manual targeting for good.",
  },
];

const AboutForAdspresso = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const urlToken = params.get("token");
  const fBData = useSelector(selectFbData);

  // Theme-based colors
  const bodyBackground = useColorModeValue(
    "background.light",
    "background.dark"
  ); // "#ffffff" | "#0b0420"
  const textColor = useColorModeValue("brand.900", "brand.500"); // or brand.200 if mapped
  const borderColor = useColorModeValue("brand.900", "brand.300"); // card border
  const subCopy = useColorModeValue("gray.700", "gray.400"); // content text
  const cardBg = useColorModeValue("brand.50", "card.dark");

  if (urlToken && fBData?.status !== "active") {
    return (
      <SidebarWithHeader>
        <Flex p={4} color="white">
          <Spinner size="md" />
        </Flex>
      </SidebarWithHeader>
    );
  }

  return (
    <SidebarWithHeader>
      <Box
        px={6}
        mt="20px"
        mx="auto"
        textAlign="center"
        // bg={bodyBackground}
        color={textColor}
      >
        <Heading size="2xl" color={textColor} mb={'10px'}>
          Get Hustlin'!
        </Heading>
        <Text mb={'40px'}>In collaboration with Meta, delivering up to 30% better results backed by Meta's data science team.
        </Text>

        <Heading size="lg" fontWeight="light" mb={6} color={textColor}>
          Features you’ll love
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
          {features.map((feature, index) => (
            <Box
              key={index}
              p={5}
              borderRadius="2xl"
              bg={cardBg}
              border={`1px solid`}
              borderColor={borderColor}
              backdropFilter="blur(10px)"
              textAlign="left"
              color={textColor}
              display="flex"
              flexDirection="column"
              height="100%"       
              minH="225px"        
            >
              <HStack spacing={4} align="flex-start">
                <Image
                  src={feature.img}
                  alt="Icon"
                  width={{ base: "50px", md: "70px" }}
                />
                <Box>
                  <Text fontWeight="bold" fontSize="xl" mb={2}>
                    {feature.title}
                  </Text>
                  <Text fontSize="sm" color={subCopy}>
                    {feature.desc}
                  </Text>
                </Box>
              </HStack>
            </Box>
          ))}
        </SimpleGrid>

      </Box>
    </SidebarWithHeader>
  );
};

export default AboutForAdspresso;